import { useEffect, useState } from 'react';

import { isTouchDevice } from './isTouchDevice';
import { DeviceType } from './types';

function userAgentToDevice(userAgent?: string): DeviceType {
  if (!userAgent) {
    return DeviceType.GENERAL;
  }

  if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
    return DeviceType.IOS;
  } else if (userAgent.includes(DeviceType.ANDROID)) {
    return DeviceType.ANDROID;
  }

  return DeviceType.GENERAL;
}

function isMobile(device: DeviceType) {
  return device === DeviceType.IOS || device === DeviceType.ANDROID;
}

export function useUserAgent(initialDevice?: DeviceType) {
  const [device, setDevice] = useState<DeviceType>(
    initialDevice || DeviceType.GENERAL
  );

  const [isDeviceResolved, setIsDeviceResolved] = useState<boolean>(
    Boolean(initialDevice)
  );
  const [isMobileDevice, setMobileDevice] = useState<boolean>(isMobile(device));
  const [isMobileTouchDevice, setMobileTouchDevice] = useState<boolean>(false);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.navigator?.userAgent) {
      const detectedDevice = userAgentToDevice(window.navigator.userAgent);
      setDevice(detectedDevice);
      setIsDeviceResolved(true);
    }
  }, []);

  useEffect(() => {
    setMobileDevice(isMobile(device));
    setMobileTouchDevice(isMobile(device) && isTouchDevice());
  }, [device]);

  return { device, isMobileDevice, isMobileTouchDevice, isDeviceResolved };
}
